import SearchHeaderComponent from '../components/shared/search-header-component.vue';
import Vue from 'vue';

const SELECTOR = '.js-header-search';

const HeaderSearch = (() => {
    class HeaderSearch {
        constructor(element) {
            this.createComponent(element);
        }

        createComponent(el) {
            return new Vue({
                components: {
                    'dm-search-header': SearchHeaderComponent
                },
                template: `<dm-search-header />`,
                el
            });
        }
    }
    return new HeaderSearch(document.querySelector(SELECTOR));
})();

export default HeaderSearch;
